import { useState } from 'react';

const REASONS = [
  'Nhập sai nội dung',
  'Chọn nhầm thửa đất/mùa vụ',
  'Ảnh đính kèm không đúng',
  'Nhật ký bị trùng',
  'Ghi nhận nhầm ngày',
  'Không còn phù hợp',
  'Khác',
];

interface LogDeleteModalProps {
  logName: string;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

export function LogDeleteModal({ logName, onConfirm, onCancel }: LogDeleteModalProps) {
  const [reason, setReason] = useState(REASONS[0]);
  const [otherReason, setOtherReason] = useState('');

  const finalReason = reason === 'Khác' ? otherReason.trim() || 'Khác' : reason;

  return (
    <div className="fixed inset-0 z-[90] flex items-end sm:items-center justify-center p-0 sm:p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className="relative bg-white rounded-t-2xl sm:rounded-2xl shadow-xl w-full sm:max-w-sm overflow-y-auto max-h-[100dvh] sm:max-h-[90vh]">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-slate-100 px-4 sm:px-6 py-3 flex items-center justify-between z-10">
          <h3 className="text-base sm:text-lg font-semibold text-slate-900">Xóa nhật ký</h3>
          <button
            type="button"
            onClick={onCancel}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 text-slate-400"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <div className="px-4 sm:px-6 py-4">
          <p className="text-sm text-slate-600 mb-4">
            Bạn có chắc muốn xóa nhật ký <span className="font-medium">"{logName}"</span>?
            Nhật ký sẽ bị ẩn khỏi danh sách mặc định.
          </p>

          <p className="text-sm font-medium text-slate-700 mb-2">Chọn lý do xóa:</p>
          <div className="space-y-2 mb-4 max-h-[200px] overflow-y-auto">
            {REASONS.map((r) => (
              <label key={r} className="flex items-start gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="deleteReason"
                  value={r}
                  checked={reason === r}
                  onChange={() => setReason(r)}
                  className="mt-0.5 accent-agrida-600"
                />
                <span className="text-sm text-slate-700">{r}</span>
              </label>
            ))}
          </div>

          {reason === 'Khác' && (
            <input
              type="text"
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
              placeholder="Nhập lý do khác..."
              className="w-full px-3 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-agrida-500 mb-4"
            />
          )}

          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 rounded-md text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 transition-colors whitespace-nowrap min-h-[44px]"
            >
              Hủy
            </button>
            <button
              type="button"
              onClick={() => onConfirm(finalReason)}
              className="px-4 py-2 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors whitespace-nowrap min-h-[44px]"
            >
              Xác nhận xóa
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
